import storage from 'redux-persist/lib/storage';
import { createTransform, persistReducer } from 'redux-persist';

const resetarAutenticacaoEmAndamento = createTransform(
  (state) => ({
    ...state,
    autenticandoLoja: false,
    autenticandoPainel: false,
    autenticandoPainelRelatorio: false,
  }),
  (state) => ({
    ...state,
    autenticandoLoja: false,
    autenticandoPainel: false,
    autenticandoPainelRelatorio: false,
  }),
  { whitelist: ['autenticacao'] }
);

export default (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: 'sherwin-williams',
      storage,
      whitelist: ['autenticacao', 'usuario', 'parceiro'],
      transforms: [resetarAutenticacaoEmAndamento],
    },
    reducers
  );

  return persistedReducer;
};
